import React from "react";
import { X } from "lucide-react";

export const LegalModal = ({ isOpen, onClose, title, icon: Icon, testId, closeTestId, children }) => {
  if (!isOpen) return null;

  return (
    <div
      data-testid={testId}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-[#efe7dd] border border-[#b58e70]/40 max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-[#b58e70]/30 px-6 py-5 bg-[#e5d8cb] shrink-0">
          <h3 className="font-serif text-xl sm:text-2xl text-[#1c110e] tracking-tight font-light flex items-center gap-2">
            {Icon && <Icon className="w-5 h-5 text-[#d97036]" />}
            {title}
          </h3>
          <button
            onClick={onClose}
            data-testid={closeTestId}
            className="text-[#5a4b46] hover:text-[#d97036] transition-colors p-1"
            aria-label="Schließen"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content Body */}
        <div className="px-8 py-8 space-y-6 font-sans text-sm text-[#5a4b46] font-light leading-relaxed overflow-y-auto">
          {children}
        </div>

        {/* Footer */}
        <div className="border-t border-[#b58e70]/30 px-6 py-4 flex justify-end bg-[#e5d8cb] shrink-0">
          <button
            onClick={onClose}
            className="bg-[#8a2424] text-[#f7f2ed] hover:bg-[#a32e2e] transition-colors px-6 py-2.5 uppercase tracking-wider text-xs font-semibold"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
};
